import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'SkipToContent',
})(({ zLevels, brandColors }) => ({
  link: {
    position: 'absolute',
    zIndex: zLevels.popover,
    margin: '0 auto',
    top: '1rem',
    right: 0,
    left: 0,
    backgroundColor: `${brandColors.chargeYellow} !important`,
    transition: 'transform 0.1875s ease-out, opacity 0.1875s ease-out',

    // Hidden by default
    opacity: 0,
    transform: 'translateY(-4rem)',

    // Show when focused (for keyboard navigation)
    '&:focus': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

export default useStyles;
